import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  styled,
} from '@mui/material';

const documents = [
  {
    title: "Lois",
    link: "/legalFramework",
    description: "Explorez les lois et règlements qui régissent les activités de l'INSBU, essentiels pour comprendre le cadre opérationnel de la statistique au Burundi."
  },
  {
    title: "Ordonnances",
    link: "/ordinances",
    description: "Consultez les ordonnances relatives aux pratiques statistiques, qui fournissent des directives sur la collecte et l'utilisation des données."
  },
  {
    title: "Décrets",
    link: "/decrees",
    description: "Accédez aux décrets régissant les normes et les procédures statistiques, garantissant la qualité et la fiabilité des données."
  },
  {
    title: "Codes de conduite",
    link: "/pageCodes",
    description: "Découvrez les codes de conduite édictés pour assurer l'intégrité et la confidentialité des données statistiques."
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: '#388E3C', 
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
}));

function DocumentINSBU() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
        Cadre Juridique et Législatif de l'INSBU
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          L'Institut National de la Statistique du Burundi (INSBU) met à votre disposition l'ensemble du 
          <span style={{ color: '#388E3C', fontWeight: 500 }}> dispositif législatif et réglementaire </span> 
          encadrant la production statistique nationale.
        </Typography>

        <Grid container spacing={2} style={{ marginTop: '20px' }}>
          {documents.map((document, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <StyledCard>
                <StyledCardActionArea href={document.link}  rel="noopener noreferrer">
                  <StyledCardContent>
                    <TitleTypography variant="h6" component="div">
                   {document.title}
                    </TitleTypography>
                    <DescriptionTypography variant="body2">
                      {document.description}
                    </DescriptionTypography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default DocumentINSBU;